module.exports = __webpack_public_path__ + "static/save_as_template_1-fd717a9118709538f8e678c3247f0bf5.png";